/**
 * @vm/ui - UI component library
 *
 * Main export: all client-safe components
 * For types: import from "@vm/ui/types"
 */

// Core components
export * from "./components/AppShell";
export * from "./components/Button";
export * from "./components/PricingTable";
export * from "./components/Landing";
export * from "./components/ShaderBackground";
export * from "./components/HeroSection";
export * from "./components/GlassNavigation";
export * from "./components/GlassPricing";
export * from "./components/iridescent-shader";
export * from "./components/GoogleSignInButton";

// Icons
export * from "./icons/GoogleIcon";

// Dashboard components
export * from "./dashboard/DashboardShell";
export * from "./dashboard/Sidebar";
export * from "./dashboard/Topbar";
export * from "./dashboard/Card";

// Dashboard widgets (Van Moose Design System)
export * from "./dashboard/StatusBanner";
export * from "./dashboard/KPIGrid";
export * from "./dashboard/EntityGrid";
export * from "./dashboard/ActivityFeed";
export * from "./dashboard/AlertsPanel";

// Modals
export * from "./modals/HabitCreationModal";